import React from 'react';
import RequestFormComponent from '@websky/core/src/Refund/Components/RequestForm/RequestForm';
const RequestForm = props => {
    return React.createElement(RequestFormComponent, Object.assign({}, props, { isRulesOptional: true }));
};
export default RequestForm;
